import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import ConsoleWrapper from '../../../components/endpoints-page/console';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Get GIFs by ID Endpoint`}</h2>
    <p>{`Get GIFs by ID returns metadata of multiple GIFs based on the GIF IDs specified.`}</p>
    <ConsoleWrapper mdxType="ConsoleWrapper">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`URL`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`api.giphy.com/v1/gifs`}</td>
          </tr>
        </tbody>
      </table>
    </ConsoleWrapper>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Request Parameters:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description:`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`api_key`}</strong>{`: `}<em parentName="td">{`string(required)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`YOUR_API_KEY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`GIPHY API Key.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`ids`}</strong>{`: `}<em parentName="td">{`string(required)`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`xT4uQulxzV39haRFjG, 3og0IPxMM0erATueVW`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Filters results by specified GIF IDs, separated by commas.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`random_id`}</strong>{`: `}<em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`e826c9fc5c929e0d6c6d423841a282aa`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An ID/proxy for a specific user.`}</td>
        </tr>
      </tbody>
    </table>
    <h5>{`Successful Response (200 OK)`}</h5>
    <ConsoleWrapper mdxType="ConsoleWrapper">
    <ul>
        <li>
            data: <a href="/docs/api/schema#gif-object">GIF Object[]</a>
        </li>
        <li>
            pagination: <a href="/docs/api/schema#pagination-object">Pagination Object</a>
        </li>
        <li>
            meta: <a href="/docs/api/schema#meta-object">Meta Object</a>
        </li>
    </ul>
    </ConsoleWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      